import { updatePatients } from "actions";
import axios from "axios";
import ConfirmModal from "components/Modals/confirm-modal";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { capitalizeWords } from "utils/formaters";

export default function DoctorsPatientBar({patient}) {
    const {user} = useSelector(state => state)
    const history = useHistory()
    const [showPopUpDelete, setShowPopUpDelete] = useState(false)
    const dispatch = useDispatch()
    const fixPatient = {
        Name: `${patient.firstName} ${patient.lastName}`,
        ID: patient.idNumber,
        'Phone Number': patient.phoneNumber,
        Gender: capitalizeWords(patient.gender),
        DOB: patient.dateOfBirth
    }
    const handleRemove = async () =>{
        const status = 'removed-by-doctor' 
        const status_checked = false
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/app/doctor/update-relation-status`,
            {doctor_id: user.data.id, patient_id:patient.id, status},
            { headers: {'Authorization': `Bearer ${user.jwtToken}`} }) 
            await axios.post(`${process.env.REACT_APP_API_URL}/app/doctor/update-status-checked`,
            {doctor_id: user.data.id, patient_id:patient.id, status_checked},
            { headers: {'Authorization': `Bearer ${user.jwtToken}`} }) 
            dispatch( updatePatients({...patient, status}) )
            history.push('/dashboard')
        } catch (error) {
            console.log('error',error)
        }
    }

    return (
        <div style={{width:'100%', color:'#636E72'}}>
            {showPopUpDelete && 
                <ConfirmModal 
                    text={`Are you sure you want to remove ${fixPatient.Name} from your patient list ?`}
                    onConfirm={handleRemove}
                    onCancel={setShowPopUpDelete}
                />
            }
            <div style={{backgroundColor:'#EBEBEB',padding:'10px',display:'flex'}}>
                <Link style={{margin:'auto 5px', color:'#636E72'}} to="/dashboard" >
                    <i className="fas fa-arrow-circle-left" style={{color:'#3FA842',marginRight:'7px'}}/> 
                     Back to list
                </Link>
                {['Name','ID', 'Phone Number', 'Gender','DOB'].map(key=>
                 <div key={key} style={{margin:'auto 25px', color:'#636E72'}}> 
                    {key}:  
                    <div style={{display:'inline', color:'#3FA842'}} > {fixPatient[key]} </div> 
                </div>
                )}
                <div style={{margin:'auto 11px auto auto', cursor:'pointer'}} onClick={() => setShowPopUpDelete(true)}>
                    <i className="fas fa-times-circle" style={{color:'#3FA842',marginRight:'7px'}}/>
                    Remove patient
                </div>
            </div>
        </div>
    )
}